
import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Country } from './types';

interface CountrySelectorProps {
  countries?: Country[];
  selectedCountry: string | null;
  onCountryChange: (value: string) => void;
}

export const CountrySelector = ({
  countries,
  selectedCountry,
  onCountryChange,
}: CountrySelectorProps) => {
  // Find the selected country's name for display
  const selectedCountryName = React.useMemo(() => {
    if (!selectedCountry || !countries) return null;
    const country = countries.find(c => c.code === selectedCountry);
    return country?.name || null;
  }, [selectedCountry, countries]);

  return (
    <Select
      value={selectedCountry || undefined}
      onValueChange={(value) => {
        console.log('Selected country code:', value);
        onCountryChange(value);
      }}
    >
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select your country">
          {selectedCountryName || "Select your country"}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {countries?.map((country) => (
          <SelectItem key={country.id} value={country.code}>
            {country.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
